export const environment = {
  production: true,
  clientId: '261302296103747584',
  loginURL: 'https://discordapp.com/api/oauth2/authorize',
  apiURL: 'https://api.avrae.io',
  mediaURL: 'https://media.avrae.io',
  baseURL: 'https://avrae.io',
  datadogAplicationId: '7350206a-687c-4dc4-942b-c3f0d1bb024b',
  datadogClientToken: 'pubf700faf5c2632d84266ee5171c2eb062',
  allowedExternalOauths: ["https://bestiarybuilder.com"]
};
